<script lang="ts">
    import Logo from "../Logo.svelte";
</script>

<a href="/">
    <header class="flex justify-center">
        <Logo class="w-40" />
    </header>
</a>
